import { Box, Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { Trans } from "@lingui/macro";
import React from "react";
import { isBefore } from "../../utils/dateUtils";
// theme
import theme from "../../theme";

const useStyles = makeStyles((theme) => ({
  item: {
    padding: theme.spacing(2),
    position: "relative",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.lightGray,
    },
  },
  spaceName: {
    fontWeight: "bold",
  },
  notificationIcon: {
    position: "absolute",
    right: 10,
    width: 11,
    height: 11,
    color: theme.palette.primary.main,
    fontSize: "small",
  },
}));

const NotificationItem = ({ bookingId, status, spaceTitle, projectName, onClick }) => {
  const classes = useStyles(theme);

  const handleClickItem = () => onClick(status, bookingId);

  return (
    <Box>
      <Box className={classes.item} onClick={handleClickItem}>
        <Typography variant="body1">
          <Trans>Novedades en </Trans>
          <FiberManualRecordIcon className={classes.notificationIcon} />
        </Typography>
        <Typography variant="body1" className={classes.spaceName}>
          {spaceTitle ? `${spaceTitle} - ` : ""} {projectName}
        </Typography>
        <Typography variant="body1">#{bookingId}</Typography>
      </Box>
      <Divider />
    </Box>
  );
};

export default NotificationItem;
